import { LayersList } from "@/config/dm.export.config";

const state = {
  exportTileLayer: LayersList?.[0].title ?? "",
  format: {},
  graphLayer: null,
  selectedFeatureList: null,
  others: "",
  dap: "",
  tiff: false,
  jpeg: false,

};

const getters = {};

const actions = {};

const mutations = {
  setExportTileLayer(state, Layer) {
    state.exportTileLayer = Layer ?? "";
  },
  setSelectedFormat(state, formats) {
    state.format[formats.layer] = formats.formats;
  },
  setQraphLayer(state, graphLayer) {
    state.graphLayer = graphLayer;
  },
  setSelectedFeatureList(state, list) {
    state.selectedFeatureList = list;
  },
  setUAVTIFF(state, f) {
    state.tiff = f;
  },
  setUAVJPEG(state, f) {
    state.jpeg = f;
  },
  setOthers(state, othersList) {
    state.others = othersList;
  },
  setDap(state, dapList) {
    state.dap = dapList;
  },
  resetData(state) {
    state.dap = "";
    state.others = "";
    state.tiff = state.jpeg = false;
    state.graphLayer = null;
    state.selectedFeatureList = null;
    state.exportTileLayer = "";
    state.format = {};
  }

};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
